import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-tr-new-job-conf',
  templateUrl: './tr-new-job-conf.component.html',
  styleUrls: ['./tr-new-job-conf.component.css']
})
export class TrNewJobConfComponent implements OnInit {
    labourNo;

    public argType: string;

    argValue;

    public edit?: Edit;

    public selectListOffDutyCodes: OffDutyCodeItem[] = [];

    public itemsListExtraPowTimes: Item[] = [];

    public confirming = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadEdit() {
        if (!!this.labourNo && !!this.argType && !!this.argValue) {
            this.edit = (await this.datatask.Post(125, {
                labour_no: this.labourNo,
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadOffDutyCodes() {
        this.selectListOffDutyCodes = await this.datatask.Post(2125);
    }

    private async loadExtraPowTimes() {
        if (!this.edit) return;

        return this.itemsListExtraPowTimes = await this.datatask.Post(3423, this.edit);
    }

    private async retrieveOvertime() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(148, {
            labour_no: this.edit.labour_no,
            dt_start: this.edit.old_job_start,
            dt_end: this.edit.timestamp_out_corrected
        }))[0];

        if (response?.overtime_hours !== '0.00') {
            this.edit.overtime_hours = response?.overtime_hours;
        }
    }

    public async confirmChanges() {
        if (!!this.edit) {
            try {
                this.confirming = true;

                const mergeObj = {
                	...this.edit,
                    powtimeextras: this.itemsListExtraPowTimes
                }

                const response = (await this.datatask.Post(142, mergeObj))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.confirming = false;
            }
        }
    }

    private offDutyCodeChanged() {
        if (!this.edit) return;

        let i;

        for (i = 0; i < this.selectListOffDutyCodes.length; i++) {
            if (this.selectListOffDutyCodes[i].item_id && this.selectListOffDutyCodes[i].item_id !== '0') {
                if (this.edit.offdutycode_keyno === this.selectListOffDutyCodes[i].item_id) {
                    this.edit!.offdutycode_specification_required = this.selectListOffDutyCodes[i].note_required;
                    return;
                }
            } else {
                this.edit.offdutycode_specification_required = '0';
            }
        }
    }

    public cancelToTrStart() {
        this.stateService.back();
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'timestamp_out_corrected':
                if (this.edit.stamped === '1') this.retrieveOvertime();
                break;
            case 'offdutycode_keyno':
                this.offDutyCodeChanged();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadOffDutyCodes();
        this.loadExtraPowTimes();

        if (this.edit!.missingexit === '1') {
            this.edit!.overtime_hours = '0.00';
        }

        if (this.edit!.stamped === '1') this.retrieveOvertime();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    message_text: string;
    labour_name: string;
    message_text_out: string;
    labour_no: string;
    salary_extra_01: string;
    salary_extra_02: string;
    salary_extra_03: string;
    time_newjob: string;
    stamped: string;
    missingexit: string;
    timestamp_out_corrected: string;
    breakminutes: string;
    salary_extra_01_name: string;
    salary_extra_02_name: string;
    salary_extra_03_name: string;
    overtime_hours: string;
    old_job_start: string;
    overtime_to_personal_timeaccount: string;
    job_note: string;
    argtype: string;
    argvalue: string;
    offdutycode_keyno: string;
    offdutycode_specification_required: string;
    offdutycode_specification: string;
    powtime_keyno: string;
}

interface OffDutyCodeItem {
    item_id: string;
    item_name: string;
    orderby: number;
    note_required: string;
    salarytype_id_pay: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeRegisterNewJobConf', {
//        templateUrl: 'views/components/views/trNewJobConf/trNewJobConf.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'trNewJobConfService', 'timeRegisterService', function ($stateParams, stateService, utilityService, translateService, modalService, trNewJobConfService, timeRegisterService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                argtype: argType,
//                offDutyCodeButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('offdutycode_keyno') }
//                ],
//                edit: {},
//                selectListOffDutyCodes: [],
//                itemsListExtraPowTimes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await trNewJobConfService.getEdit({
//                    labour_no: labourNo,
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadSelectOffDutyCodes() {
//                vm.model.selectListOffDutyCodes = await trNewJobConfService.listSelectOffDutyCodes();
//            }

//            async function retrieveOvertime() {
//                if (utilityService.validateParmsValue(vm.model.edit.labour_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.old_job_start) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.timestamp_out_corrected) !== true) return;

//                const response = (await trNewJobConfService.getOvertime({
//                    labour_no: vm.model.edit.labour_no,
//                    dt_start: vm.model.edit.old_job_start,
//                    dt_end: vm.model.edit.timestamp_out_corrected
//                }))[0];

//                if (response?.overtime_hours !== '0.00') {
//                    vm.model.edit.overtime_hours = response?.overtime_hours;
//                }
//            }

//            async function loadExtraPowTimes() {
//                return vm.model.itemsListExtraPowTimes = await timeRegisterService.listExtraPowTimes(vm.model.edit);
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region CHANGE FUNCTION

//            function offDutyCodeChanged() {
//                let i;

//                for (i = 0; i < vm.model.selectListOffDutyCodes.length; i++) {
//                    if (vm.model.selectListOffDutyCodes[i].item_id && vm.model.selectListOffDutyCodes[i].item_id !== '0') {
//                        if (vm.model.edit.offdutycode_keyno === vm.model.selectListOffDutyCodes[i].item_id) {
//                            vm.model.edit.offdutycode_specification_required = vm.model.selectListOffDutyCodes[i].note_required;
//                            return;
//                        }
//                    } else {
//                        vm.model.edit.offdutycode_specification_required = '0';
//                    }
//                }
//            }

//            // #endregion CHANGE FUNCTION

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'offdutycode_keyno':
//                        vm.model.edit.offdutycode_keyno = '0';

//                        if (vm.model.edit.offdutycode_keyno === '0') offDutyCodeChanged();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let mergeObj = {};
//                mergeObj = angular.copy(vm.model.edit);
//                mergeObj.powtimeextras = vm.model.itemsListExtraPowTimes;

//                trNewJobConfService.saveObj(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        stateService.back('/' + 'trstart');
//                        vm.model.lockedSave = false;
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region CANCEL BUTTON FUNCTION

//            vm.cancelToTrStart = function () {
//                stateService.back();
//            }

//            // #endregion CANCEL BUTTON FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'timestamp_out_corrected':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.timestamp_out_corrected) !== true) return;

//                        vm.model.edit.timestamp_out_corrected = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.timestamp_out_corrected) !== true) return;

//                        if (vm.model.edit.stamped === '1') retrieveOvertime();
//                        break;
//                    case 'offdutycode_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.offdutycode_keyno) !== true) return;

//                        vm.model.edit.offdutycode_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.offdutycode_keyno) !== true) return;

//                        if (vm.model.edit.offdutycode_keyno !== '0') offDutyCodeChanged();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadSelectOffDutyCodes();
//                loadExtraPowTimes();

//                if (vm.model.edit.missingexit === '1') vm.model.edit.overtime_hours = '0.00';
//                if (vm.model.edit.stamped === '1') retrieveOvertime();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
